/* @flow */
import * as React from 'react';
import styles from './styles.module.scss';

type Props = {
  children?: any,
  alwaysShowScrollbar?: boolean,
};

export default React.forwardRef((props: Props, ref: any) => {
  const { alwaysShowScrollbar, children, ...restProps } = props;
  return (
    <div
      {...restProps}
      ref={ref}
      className={alwaysShowScrollbar ? styles.alwaysScrollable : styles.scrollable}
    >
      {children}
    </div>
  );
});
